import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';

import { SiteIconService } from '../../services/site-icon.service';
import { CurrentSiteService } from '../../services/current-site.service';
import { FileInputUtil } from '../../utility-classes/file-input.util';
import { MonitorIconUploadHelper } from './monitor-icon-upload.helper';
import { AsyncJobService } from '../../services/async-job.service';
import { AsyncJob } from '../../models/async-job.model';

@Component({
    selector: 'app-upload-icon',
    templateUrl: './upload-icon.dialog.html',
    styleUrls: ['./upload-icon.dialog.scss'],
    standalone: false
})
export class UploadIconDialog implements OnInit {
    // Properties.
    @ViewChild('selectIconFile') selectIconFile;

    private iconFile: File = null;
    private iconName: string = '';
    private uploadingIconFlag: boolean = false;
    private uploadStatus: string = '';

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<UploadIconDialog>,
        @Inject(MAT_DIALOG_DATA) public initObjectNotPresentlyUsed: any,
        private siteIconService: SiteIconService,
        private currentSiteService: CurrentSiteService,
        private asyncJobService: AsyncJobService)
    {
    }

    // Life cycle methods.
    ngOnInit(): void {
    }

    // Define methods called by my HTML code.
    public get IconFileSelected(): boolean {
        return this.iconFile != null;
    }
    public get SelectedFileName(): string {
        return this.iconFile != null ? this.iconFile.name : '';
    }

    public get IconName(): string {
        return this.iconName;
    }
    public set IconName(value: string) {
        this.iconName = value;
    }

    public get IconUploading(): boolean {
        return this.uploadingIconFlag;
    }

    public get UploadStatus(): string {
        return this.uploadStatus;
    }
    
    // Handle control events.
    public iconNameChanged(): void {
        // Note:  this method is handy for debugging.
    }

    public loadIconFileClicked(): void {
        FileInputUtil.clearFileSelection(this.selectIconFile);
        this.selectIconFile.nativeElement.click();
    }
    public onIconFileChanged(eventData: any): void {
        let iconFileNativeElement = this.selectIconFile.nativeElement;
        this.iconFile = iconFileNativeElement.files[0];
    }

    public uploadIcon(): void {
        this.siteIconService.addSiteIcon(this.currentSiteService.Site.id, this.iconName, this.iconFile).then(asyncJob => {
            this.uploadingIconFlag = true;
            this.uploadStatus = 'Uploading image ...';

            let jobMonitor: MonitorIconUploadHelper = new MonitorIconUploadHelper(this.asyncJobService);
            jobMonitor.startMonitoringJob(asyncJob, this.iconUploadJobUpdateArrowFunction);
        });
    }

    public cancelClicked(): void {
        this.dialogRef.close(null);
    }

    // Define helper methods.
    private iconUploadJobUpdateArrowFunction = (asyncJob: AsyncJob): void => {
        if ((asyncJob.status == AsyncJob.STATUS_COMPLETE) || (asyncJob.status == AsyncJob.STATUS_COMPLETE_ERROR)) {
            this.uploadingIconFlag = false;
            if ((asyncJob.stdError == null) || (asyncJob.stdError.trim() == ''))
                this.uploadStatus = 'Image upload completed';
            else
                this.uploadStatus = asyncJob.stdError;
        }
    }

}
